<!--共享库存订单列表--即现货订单-->
<template>
    <div id="siOrdersList" class="business-content-main">
        <div class="bread-nav">
            <div>您当前位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>客服</el-breadcrumb-item>
                <el-breadcrumb-item>共享库存</el-breadcrumb-item>
                <el-breadcrumb-item>现货订单</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-name">单号:</div>
            <el-input
                style="width: 200px"
                class="search-item"
                size="small"
                v-model.trim="searchParams.osn"
                placeholder="请输入单号"
            ></el-input>
            <div class="search-name">客户:</div>
            <!-- <el-input
                style="width: 200px"
                class="search-item"
                size="small"
                v-model.trim="searchParams.cname"
                placeholder="请输入客户名称"
            ></el-input> -->
             <el-autocomplete
              class="search-item"
              v-model="searchParams.cname"
              :fetch-suggestions="querySearch"
              placeholder="客户名称"
              size="small"
              clearable
            ></el-autocomplete>
            <div class="search-name">状态:</div>
            <el-select
                size="small"
                class="search-item"
                v-model="searchParams.state"
                placeholder="请选择"
            >
                <el-option
                    v-for="item in StateList"
                    :key="item.TKey"
                    :label="item.TValue"
                    :value="item.TKey"
                ></el-option>
            </el-select>
            <div>
                <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-search"
                    class="search-btn"
                    @click="handleSearch"
                >查询</el-button>
                <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-refresh"
                    class="search-btn"
                    @click="resetSearch"
                >重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{background:'#F2F6FC'}"
                :data="siOrdersList.data"
                border=""
                style="width: 100%"
            >
                <el-table-column show-overflow-tooltip prop="Osn" label="单号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="CName" label="客户"></el-table-column>
                <el-table-column show-overflow-tooltip prop="PhoneNum" label="联系电话"></el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    width="90px"
                    prop="SurplusMoney"
                    label="订单金额"
                ></el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    width="110px"
                    prop="GoodsCategoryCount"
                    label="商品种类数量"
                ></el-table-column>
                <el-table-column show-overflow-tooltip width="90px" prop="GoodsCount" label="商品总数"></el-table-column>
                <el-table-column show-overflow-tooltip prop="CreateTime" label="创建时间"></el-table-column>
                <el-table-column show-overflow-tooltip prop="StateName" label="状态"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="openOrderDetailDialog(scope.row.OrderId)"
                            v-if="permission.查看"
                        >查看</el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="ConfirmOrder(scope.row,scope.$index)"
                            v-if="scope.row.OrderState==40&&permission.确认订单"
                        >确认订单</el-button>
                        <el-button
                            type="text"
                            size="small"
                            style="color:#f56c6c;"
                            @click="openCancelOrderDialog(scope.row,scope.$index)"
                            v-if="scope.row.OrderState==40&&permission.取消订单"
                        >取消</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchParams.page"
                :page-size="searchParams.limit"
                :page-sizes="[10, 20, 30, 40, 50]"
                layout="total, sizes, prev, pager, next, jumper"
                :total="siOrdersList.totalCount"
            ></el-pagination>
        </div>
        <el-dialog title="取消订单" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
            <div class="dialog-content">
                <el-form
                    :model="setOrderStateReqData"
                    ref="cancelOrderForm"
                    label-width="80px"
                    size="mini"
                >
                    <el-form-item
                        label="原因"
                        prop="cancelReason"
                        :rules="[{ required: true, message: '请输入取消原因'}]"
                    >
                        <el-input
                            v-model="setOrderStateReqData.cancelReason"
                            autocomplete="off"
                            type="textarea"
                            placeholder="请输入取消原因"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('cancelOrderForm')">取 消</el-button>
                <el-button type="primary" @click="SaveCancelOrder('cancelOrderForm')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="订单明细" :visible.sync="dialogOrderDetailVisible" width="75%">
            <el-table
                :header-cell-style="{background:'#F2F6FC'}"
                :data="SIOrderGoodsList"
                border=""
                style="width: 100%"
            >
                <el-table-column prop="MainImg" label="图片" align="center" width="100px">
                    <template slot-scope="scope" align="center">
                        <!-- <el-image
                            style="width: 70px; height: 70px"
                            :src="scope.row.MainImg+'?imageView2/2/w/200'"
                            :preview-src-list="[scope.row.MainImg]"
                            lazy
                        >
                            <div slot="error" class="image-slot">
                                <i class="el-icon-picture-outline"></i>
                            </div>
                        </el-image> -->
                             <div v-viewer="options" >
                              <template>
                                <img 
                                  :src="scope.row.MainImg+'?imageView2/2/w/200'" class="formImg" 
                                  :data-src="scope.row.MainImg"
                                >
                              </template>
                            </div>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="APCode" label="汽配编码"></el-table-column>
                <el-table-column show-overflow-tooltip prop="GoodsName" label="商品名称"></el-table-column>
                <el-table-column show-overflow-tooltip prop="Unit" label="单位"></el-table-column>
                <el-table-column show-overflow-tooltip width="90px" prop="Count" label="数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="90px" prop="SalesPrice" label="价格"></el-table-column>
                <el-table-column show-overflow-tooltip prop="PlatformServiceFee" label="服务费"></el-table-column>
                <el-table-column show-overflow-tooltip prop="TotalPrice" label="总价"></el-table-column>
            </el-table>
        </el-dialog>
    </div>
</template>

<script>
import Vue from 'vue'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
Vue.use(Viewer);

export default {
  name: "siOrdersList",
  components: {},
  data() {
    return {
      imgcdn: this.$util.QN_URL_BASE,
      dialogFormVisible: false,
      StateList: [{ Tkey: "-1", TValue: "请选择" }],
      searchParams: {
        cname: "",
        osn: "",
        state: "-1",
        page: 1,
        limit: 10
      },
      siOrdersList: {
        data: [],
        totalCount: 0 //总页数
      },
      //设置订单状态的请求对象
      setOrderStateReqData: {
        orderId: "",
        state: "",
        cancelReason: "",
        index: 0
      },
      dialogOrderDetailVisible: false,
      //订单商品列表
      SIOrderGoodsList: [],
      permission: {},
      options: {
        url: 'data-src',
        zIndex: 9999
      },
    };
  },
  mounted() {
    this.getSIOrderList();
    this.getSIOrderStatesList();
    this.$util.getPermission("现货订单").then(res => {
      this.permission = res;
    });
  },
  methods: {
    //搜索按钮事件
    handleSearch() {
      this.searchParams.page = 1;
      this.getSIOrderList();
    },
    resetSearch() {
      this.searchParams = {
        code: "",
        goodsName: "",
        autoSerise: "",
        page: 1,
        limit: 10
      };
    },
    handleSizeChange(val) {
      this.searchParams.page = 1;
      this.searchParams.limit = val;
      this.getSIOrderList();
    },
    handleCurrentChange(val) {
      this.searchParams.page = val;
      this.getSIOrderList();
    },
    //获取订单状态列表
    getSIOrderStatesList() {
      var that = this;
      this.axios
        .get("/ShareInventory/GetSIOrderStates", {
          params: that.searchParams
        })
        .then(result => {
          that.StateList = result.data.data;
        });
    },
    //获取现货订单列表
    getSIOrderList() {
      var that = this;
      this.axios
        .get("/ShareInventory/GetSIOrderList", {
          params: that.searchParams
        })
        .then(result => {
          that.siOrdersList = {
            data: result.data.data,
            totalCount: result.data.count
          };
        });
    },
    //确认订单
    ConfirmOrder(item, index) {
      let that = this;
      this.$confirm("是否确认订单?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        that.setOrderStateReqData.OrderId = item.OrderId;
        that.setOrderStateReqData.state = "1";
        let _formData = that.setOrderStateReqData;
        that.axios
          .post("/ShareInventory/SetSIOrderState", _formData)
          .then(res => {
            let result = res.data;
            if (result.errcode == 0) {
              that.siOrdersList.data[index].OrderState = 60;
              that.siOrdersList.data[index].StateName = "已确认订单";
              that.$util.successMsg("确认订单成功");
            } else {
              that.$util.errorMsg(result.errmsg);
            }
          })
          .catch(err => {
            let result = err.data;
            if (result) {
              that.$util.errorMsg(result.errmsg);
            } else {
              this.$message.error("确认失败！");
            }
          });
      }).catch(()=>{});
    },
    //打开取消订单弹窗
    openCancelOrderDialog(row, index) {
      this.dialogFormVisible = true;
      this.setOrderStateReqData.orderId = row.OrderId;
      this.setOrderStateReqData.cancelReason = "";
      this.setOrderStateReqData.index = index;
    },
    //取消订单弹窗
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs[formName].clearValidate();
      this.dialogFormVisible = false;
    },
    //保存取消订单
    SaveCancelOrder(formName) {
      let that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          let index = that.setOrderStateReqData.index;
          that.setOrderStateReqData.state = "0";
          let _formData = that.setOrderStateReqData;
          that.axios
            .post("/ShareInventory/SetSIOrderState", _formData)
            .then(res => {
              let result = res.data;
              if (result.errcode == 0) {
                that.siOrdersList.data[index].OrderState = 160;
                that.siOrdersList.data[index].StateName = "已取消订单";
                that.$util.successMsg("取消订单成功");
                that.dialogFormVisible = false;
              } else {
                that.$util.errorMsg(result.errmsg);
              }
            })
            .catch(err => {
              let result = err.data;
              if (result) {
                that.$util.errorMsg(result.errmsg);
              } else {
                this.$message.error("取消失败！");
              }
            });
        }
      });
    },
    //打开订单详细
    openOrderDetailDialog(orderId) {
      var that = this;
      this.axios
        .get("/ShareInventory/GetSIOrderGoodsList?orderId=" + orderId)
        .then(resp => {
          var goodslist = [];
          resp.data.data.forEach(e => {
            if (e.MainImg) {
              e.MainImg = that.imgcdn + e.MainImg;
            }
            goodslist.push(e);
          });
          that.SIOrderGoodsList = goodslist;
          that.dialogOrderDetailVisible = true;
        })
        .catch(err => {
          let result = err.data;
          if (result) {
            that.$util.errorMsg(result.errmsg);
          } else {
            this.$message.error("获取订单商品列表失败！");
          }
        });
    },
       querySearch(queryString, cb) {
      this.$util.searchEntp(queryString).then(data => {
        let customerList = [];
        let result=data.data;
        for (let i in result) {
          customerList.push({
            value: result[i].Name
          });
        }
        cb(customerList);
      });
    }
  }
};
</script>
<style lang="less" >
.image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
}
.formImg{
  cursor: pointer;
  width: 70px;
  height: 70px;
}
</style>